// EPWA-872 Tipi del contratto BE per il calendario malattie
// (query getCalendarDays / getCalendarColors / getTagColors, client agromodels).
// Shape allineata al Flutter (lib/models/calendar_day.dart, led_colors.dart).

/** Giorno del calendario malattie come ritornato da `getCalendarDays`. */
export interface CalendarDay {
  date: string; // Date! — `yyyy-MM-dd` (locale, NON UTC: bug giorno -1)
  outbreakRisk: number; // Int!
  damage: number | null; // Int (nullable)
  infectionRiskTag: boolean | null; // Boolean (nullable): true=infezione, false=nessuna, null=nessun dato
  noDataTag: boolean; // Boolean!
  disease: string | null; // campo extra restituito dal BE (malattia del giorno)
}

/** Riga della mappa colori sfondo: coppia (outbreakRisk, damage) → hex. */
export interface CalendarColor {
  outbreakRisk: number; // Int!
  damage: number | null; // Int (nullable)
  hex: string; // String!
}

/** Colori delle barre/LED dei tag. Un colore `null` ⇒ il tag NON va mostrato. */
export interface TagColors {
  infectionRiskTag: string; // String!
  noDataTag: string | null; // nullable (prima non lo era)
  noInfectionRisk: string | null; // nullable (prima non lo era)
}

/** Enum malattia passato come `type` a getCalendarDays. Lato FE coincide con le
 *  stringhe malattia già usate (chiavi i18n PREDICTIONCOMPONENT.*). */
export type Diseases = string;
